class CompareProduct {
  constructor() {
    this.storageKey = 'compare-products'
    this.products = []
    this.productNodes = {}

    this.addedClass = 'added-to-compare'
    this.selectors = {
      container: '[data-compare-popup]',
      compareContainer: '.compare-content__wrapper',
      wrapper: '.compare-card',
      item: '.product-card',
      compareButton: '.compare-button',
      compareText: '.compare-button-text',
      removeButton: '.compare-remove-button',
      comparePageBar: '.compare-bar',
      compareBar:'.compare-bar--list',
      count: '.compare-count'
    }
    this.container = document.querySelector(this.selectors.container);
    this.compareContainer = document.querySelector(this.selectors.compareContainer);
    this.compareBar = this.container.querySelector(this.selectors.compareBar);
    this.select = this.container.querySelector('select-component')
    this.selectPosition = this.container.querySelector('.select-custom--options')
    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])));
    this.rendered = false;
    
    if(HimiTheme.config.mqlMobile) {
      this.maxCompareItems = 2
    }else{
      this.maxCompareItems = 3
    }
    if (this.container) {
      this.init()
    }
  }

  init = () => {
    this.setCompareButtonsState();
    this.addEventToCompareButtons();
    this.updateCompareCount();
    if (this.products.length > 0) {
      this.openComparePopup();
      this.renderComparebar()
      this.setOptionState(this.select);
    }
  }

  closeButton = () => {
    addEventDelegate({
      context: this.container,
      selector: '.compare-popup__close',
      handler: () => { 
        this.closeComparePopup();
        this.rendered = false;
      }
    })
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }

  addToCompare(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle);
      this.saveToStorage();
      this.addRenderComparebar(handle)
    }
  }

  removeFromCompare(handle) {
    const prodBtn = this.container.querySelector(`.product-card [data-product-handle="${handle}"]`) 
    this.products = this.products.filter(hdl => hdl !== handle);
    this.saveToStorage();
    prodBtn && prodBtn.closest(this.selectors.wrapper).remove()
  }

  clearAllButton = () => {
    addEventDelegate({
      context: this.container,
      selector: '[data-compare-clear]',
      handler: (e) => {
        e.preventDefault()
        this.products.length = 0;
        this.saveToStorage();
        this.updateCompareCount();
        this.setCompareButtonsState();
        this.setOptionState(this.select);
        this.compareContainer.innerHTML = '';
        this.closeComparePopup();
        this.selectPosition.classList.add('select-custom--options-top');
        this.rendered = false;
      }
    })
  }

  setCompareButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.compareButton)
    buttons.forEach(btn => {
      const prodHandle = btn && btn.dataset.productHandle
      if (this.products.indexOf(prodHandle) >= 0) {
        this.toggleButtonState(btn, true)
      } else {
        if (btn && !btn.classList.contains(this.addedClass) && this.products.length >= this.maxCompareItems) {
          btn.classList.add('disabled')
        } else {
          btn.classList.remove('disabled');
          this.toggleButtonState(btn, false)
        };
      }
    })
  }

  updateCompareCount = () => {
    const size = this.products.length;
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach(elem => {
      elem.textContent = size
    })
    if (size > 1) {
      this.container.querySelector('[data-compare-button]').removeAttribute('disabled')
    } else {
      this.container.querySelector('[data-compare-button]').setAttribute('disabled', 'disabled')
    }
  }

  addEventToCompareButtons = () => {
    addEventDelegate({
      selector: this.selectors.compareButton,
      handler: (e, btn) => {
        e.preventDefault();
        const productHandle = btn && btn.dataset.productHandle;
        if (productHandle) {
          const active = this.products.indexOf(productHandle) < 0
          if (this.products.length < this.maxCompareItems && active) {
            this.toggleButtonState(btn, active)
          } else {
            this.toggleButtonState(btn)
          }
          this.updateCompareCount(); 
          this.setCompareButtonsState();
          this.setOptionState(this.select);
        }
        if (this.products.length === 0) {
          this.closeComparePopup()
        }else{
          this.openComparePopup()
        }
      }
    })
  }

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle
    const compareText = btn && btn.querySelector(this.selectors.compareText)

    if (active) {
      this.addToCompare(productHandle);
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromCompare(productHandle);
      btn.classList.remove(this.addedClass)
    }

    if (compareText) {
      const temp = compareText.dataset.revertText;
      compareText.dataset.revertText = compareText.textContent;
      compareText.textContent = temp
    }
  }

  addEventToRemoveButtons = () => {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault();
        const prod = btn && btn.closest(this.selectors.wrapper);
        prod && prod.remove()

        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          const prodBtn = this.container.querySelector(`.product-form [data-product-handle="${productHandle}"]`);
          this.removeFromCompare(productHandle);
          this.updateCompareCount();
          this.setCompareButtonsState();
          this.setOptionState(this.select);
          prodBtn && prodBtn.closest(this.selectors.wrapper).remove()
        }

        if( this.products.length === 0) {
          this.selectPosition.classList.add('select-custom--options-top');
          this.rendered = false
        }
      }
    })
  }

  renderComparebar = async () => {
    if (this.compareBar && this.products.length) {
      const promises = this.products.map(async hdl => {
        const prodHTML = await fetchCache(`/products/${hdl}?view=compare-bar`)
        const item = document.createElement("DIV");
        item.classList.add("hidden", "column", "compare-card");
        item.innerHTML = prodHTML
        if (item.querySelector(this.selectors.item)) {
          this.productNodes[hdl] = item
        }
      })

      await Promise.all(promises)

      this.products.forEach(hdl => {
        const prodNode = this.productNodes[hdl]
        if (prodNode) {
          this.compareBar.appendChild(prodNode)
          prodNode.classList.remove('hidden')
        }
      })

      this.addEventToRemoveButtons();
    }
  }

  addRenderComparebar = async (hdl) => {
    const prodHTML = await fetchCache(`/products/${hdl}?view=compare-bar`)
    const item = document.createElement("DIV");
    item.classList.add("hidden", "column", "compare-card");
    item.innerHTML = prodHTML

    if (item.querySelector(this.selectors.item)) {
      this.productNodes[hdl] = item
    }

    const prodNode = this.productNodes[hdl]
    if (prodNode) {
      this.compareBar.appendChild(prodNode)
      prodNode.classList.remove('hidden')
    }

    this.addEventToRemoveButtons();
  }

  renderCompare = async () => {
    if (this.compareContainer && this.products.length) {
      const compareButton = this.container.querySelector('[data-compare-button]');
      compareButton && compareButton.classList.add('spinner-loading');

      const promises = this.products.map(async hdl => {
        const prodHTML = await fetchCache(`/products/${hdl}?view=compare`)
        const item = document.createElement("DIV");
        item.classList.add("hidden", "column", "compare-card");
        item.innerHTML = prodHTML
        if (item.querySelector(this.selectors.item)) {
          this.productNodes[hdl] = item
        }
      })

      await Promise.all(promises)

      compareButton && compareButton.classList.remove('spinner-loading');

      this.products.forEach(hdl => {
        const prodNode = this.productNodes[hdl]
        if (prodNode) {
          this.compareContainer.appendChild(prodNode)
          prodNode.classList.remove('hidden')
        }
      })

      if (this.selectPosition && !this.rendered) {
        this.selectPosition.classList.remove('select-custom--options-top')
      }

      setTimeout(() => {this.syncHeight()}, 350);
      this.rendered = true;
    }
  }

  addRenderCompare = async (hdl) => {
    const prodHTML = await fetchCache(`/products/${hdl}?view=compare`)
    const item = document.createElement("DIV");
    item.classList.add("hidden", "column", "compare-card");
    item.innerHTML = prodHTML;
    if (item.querySelector(this.selectors.item)) {
      this.productNodes[hdl] = item
    }

    const prodNode = this.productNodes[hdl]
    if (prodNode) {
      this.compareContainer.appendChild(prodNode);
      prodNode.classList.remove('hidden')
    }

    setTimeout(() => {this.syncHeight()}, 350);
    this.rendered = true;
  }

  syncHeight= () =>{
    const elements = this.container.getElementsByClassName('product-attribute');
    if (!elements.length) return;
    const heightGroups = new Map();
    Array.from(elements).forEach(element => {
      const count = element.getAttribute('item-count');
      if (!heightGroups.has(count)) {
        heightGroups.set(count, []);
      }
      heightGroups.get(count).push(element);
    });
    heightGroups.forEach(group => {
      const maxHeight = Math.max(...group.map(el => el.offsetHeight));
      if (maxHeight > 0) {
        group.forEach(el => el.style.height = `${maxHeight}px`);
      }
    });
  }

  addEventToCompareSelect = () => {
    const selectElement = this.container.querySelector('[data-add-compare-select]');
    if (!selectElement) return;
    
    selectElement.addEventListener('change', (e) => {
      const handle = e?.target?.value;
      if ( handle && this.products.indexOf(handle) === -1 ) {
        this.addToCompare(handle);
        this.updateCompareCount();
        this.setCompareButtonsState();
        this.setOptionState(this.select);
        if (this.rendered) {
          this.addRenderCompare(handle)
        }
      }
    });
  }

  setOptionState = (element) =>{
    const optionElement = element.querySelectorAll('.select-custom--option');
    optionElement.forEach( option => {
      const prodHandle = option.dataset.value;
      if ( this.products.length >= this.maxCompareItems || this.products.indexOf(prodHandle) >= 0 ){
        option.classList.add('disabled')
      }else{
        option.classList.remove('disabled')
      }
    })
    this.products.length >= this.maxCompareItems ? element.classList.add('hidden') : element.classList.remove('hidden')
  }

  openComparePopup = () => { 
    if(this.container.style.opacity === "1") return;
    this.container.style.removeProperty("visibility");
    this.container.style.setProperty("opacity", "1");
    setTimeout(() => {
      this.container.style.setProperty("--translate-y", "0");
    }, 350);
    if(!this._eventsAdded) {
      this.renderCompareButton();
      this.clearAllButton();
      this.closeButton();
      this.addEventToCompareSelect();
      this._eventsAdded = true;
    }
  }

  closeComparePopup = () => {
    if(this.container.style.opacity === "0") return;
    this.container.style.setProperty("--translate-y", "100%");
    setTimeout(() => {
      this.container.style.setProperty("visibility", "hidden");
      this.container.style.setProperty("opacity", "0");
      this.compareContainer.innerHTML = '';
    }, 350);
  }

  renderCompareButton = () => {
    addEventDelegate({
      context: this.container,
      selector: "[data-compare-button]",
      handler: (e) => {
        e.preventDefault()
        this.compareContainer.innerHTML = '';
        this.renderCompare()
      }
    })
  }
}

HimiTheme.CompareProduct = new CompareProduct()